import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWrenchFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M9.033 21.5h5.924a.5.5 0 0 0 .5-.5v-3.473a8.15 8.15 0 0 0 4.737-7.427 8.16 8.16 0 0 0-5.046-7.562.5.5 0 0 0-.691.462v6.071a.5.5 0 0 1-.306.461l-1.956.823a.5.5 0 0 1-.39.001L9.84 9.531a.5.5 0 0 1-.306-.46V3a.5.5 0 0 0-.223-.418.5.5 0 0 0-.47-.044A8.19 8.19 0 0 0 3.807 10.1a8.18 8.18 0 0 0 4.726 7.425V21a.5.5 0 0 0 .5.5"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWrenchFilled);
export default ForwardRef;
